<script setup lang="ts">
/**
 * 📱 M6 (mobile gameplan): the title's first Android back arms the exit and
 * says so; a second press inside the window leaves the app (useBackStack).
 */
const { exitArmed } = useBackStack()
const { t } = useLocale()
</script>

<template>
  <Transition name="back-exit">
    <div v-if="exitArmed" class="back-exit-hint" role="status" data-testid="back-exit-hint">
      {{ t('app.backAgainToExit') }}
    </div>
  </Transition>
</template>

<style scoped>
.back-exit-hint {
  position: fixed;
  left: 50%;
  bottom: calc(24px + var(--safe-bottom));
  z-index: 120;
  max-width: calc(100% - 32px - var(--safe-left) - var(--safe-right));
  transform: translateX(-50%);
  padding: 10px 18px;
  border-radius: 999px;
  background: rgba(16, 30, 46, 0.88);
  color: #fff;
  font-size: 0.9rem;
  font-weight: 600;
  text-align: center;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);
  pointer-events: none;
}
.back-exit-enter-active, .back-exit-leave-active { transition: opacity 0.2s ease; }
.back-exit-enter-from, .back-exit-leave-to { opacity: 0; }
@media (prefers-reduced-motion: reduce) {
  .back-exit-enter-active, .back-exit-leave-active { transition: none; }
}
</style>
